import seo from '../data/seo.json';

export type SeoPageKey = keyof typeof seo.pages;

const absoluteUrl = (path: string) => `${seo.site.url}${path}`;

const person = {
  '@type': 'Person',
  '@id': `${seo.site.url}/#person`,
  name: 'Dara Heng',
  url: seo.site.url,
  jobTitle: [
    'Senior Product Engineer',
    'Backend-Focused Full-Stack Engineer',
  ],
  homeLocation: {
    '@type': 'City',
    name: 'London',
  },
  sameAs: [seo.site.linkedin, seo.site.github],
  knowsAbout: [
    'Backend engineering',
    'Product engineering',
    'Fintech infrastructure',
    'Open Banking',
    'Software as a Service',
    'Distributed systems',
    'Blockchain',
    'TypeScript',
    'Go',
  ],
  alumniOf: [
    {
      '@type': 'CollegeOrUniversity',
      name: 'Queensland University of Technology',
    },
    {
      '@type': 'EducationalOrganization',
      name: 'TAFE Queensland',
    },
  ],
};

export function getStructuredData(pageKey: SeoPageKey) {
  const page = seo.pages[pageKey];
  const pageUrl = absoluteUrl(page.path === '/' ? '' : page.path);
  const webPage = {
    '@type': page.schemaType,
    '@id': `${pageUrl}#webpage`,
    url: pageUrl,
    name: page.title,
    description: page.description,
    inLanguage: seo.site.language,
    isPartOf: {
      '@id': `${seo.site.url}/#website`,
    },
    creator: {
      '@id': `${seo.site.url}/#person`,
    },
  };

  if (page.schemaType === 'ProfilePage') {
    Object.assign(webPage, {
      mainEntity: {
        '@id': `${seo.site.url}/#person`,
      },
    });
  }

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${seo.site.url}/#website`,
        url: seo.site.url,
        name: seo.site.name,
        inLanguage: seo.site.language,
        publisher: {
          '@id': `${seo.site.url}/#person`,
        },
      },
      person,
      webPage,
    ],
  };
}
